import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import { departmentList } from './constants'

const Department = props => {
  const opening = `${props.count === 0 ? 'No' : props.count} Opening${props.count === 1 ? '' : 's'}`
  return (
    <Link to={props.to}
      className={`db no-underline dim black st-pa3 mh3 mb4 ba h-auto b--mid-gray w-100 w-40-m w-25-l ${props.className}`}
    >
      <p className='break norms-24 ma0 mb2'>{props.name}</p>
      {
        props.location
          ? <p className='norms-14 dark-gray ma0 st-mb3'>{props.location}</p>
          : null
      }
      <p className='norms-14 fw5 ma0'>
        {opening}
      </p>
    </Link>
  )
}

const Placeholder = props => (
  <img src='assets/spinner-square.gif'
    className='db center h-100 w-20 w-20-m w-10-l'
  />
)

class DepartmentsTable extends React.Component {
  static propTypes = {
    hideIfNoOpenings: PropTypes.bool,
    hiddenDepartments: PropTypes.arrayOf(PropTypes.string),
    departments: PropTypes.arrayOf(PropTypes.object),
    locations: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
  }

  static defaultProps = {
    hiddenDepartments: [],
    departments: [],
    locations: [],
  }

  renderDepartments () {
    const {
      hiddenDepartments,
      departments,
      locations,
    } = this.props

    return departmentList
      .filter(dep => !hiddenDepartments.includes(dep.name.toLowerCase()))
      .map(dep => {
        const depModel = departments.find(d => d.name === dep.name) || {
          id: dep.id,
          name: dep.name,
          locations: [],
          positionCount: 0,
        }

        if (depModel.positionCount === 0 && this.props.hideIfNoOpenings) {
          return null
        }

        const location = depModel.locations.reduce(
          (prev, value, index) => index === 0 ? value : `${prev} & ${value}`, ''
        )

        return (
          <Department key={depModel.id}
            name={depModel.name}
            location={location}
            count={depModel.positionCount}
            to={`/departments/${depModel.id}`}
          />
        )
      }).filter(dep => dep != null)
      .concat(
        <Department key='all'
          to='/openings'
          name='All Open Positions'
          location={
            `${locations.length} Location${locations.length === 1 ? '' : 's'}`
          }
          count={departments.reduce((prev, dep) => prev + dep.positionCount, 0)}
        />
      )
  }

  render () {
    const table = this.props.isFetching
      ? <Placeholder />
      : this.renderDepartments()

    return (
      <div className='flex flex-wrap justify-center'>
        {table}
      </div>
    )
  }
}

export default connect(
  state => state.positions,
  null
)(DepartmentsTable)
